import { useState } from 'react'
import { useIntl } from '@/intl'

export function useTexts() {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    on: translate({ id: 'global.on' }),
    orders: (count: number) => translate({ id: 'global.plural.orders', values: { count } }),
    vehicles: (count: number) => translate({ id: 'global.plural.vehicles', values: { count } }),
  }))

  return api
}
